.bookingwidget {
  position: relative;
  z-index: 40;
  &.fullscreen {
    height: auto;
  }
}

.loadingOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
